var map = {
	"./ca.json": [
		83614,
		3614
	],
	"./de.json": [
		51548,
		1548
	],
	"./en.json": [
		98946,
		8946
	],
	"./es.json": [
		66748,
		9128
	],
	"./eu.json": [
		74128,
		4128
	],
	"./fr.json": [
		16416,
		6416
	],
	"./it.json": [
		6816,
		6816
	],
	"./ja.json": [
		67544,
		7544
	],
	"./nl.json": [
		82376,
		2376
	],
	"./pt.json": [
		66976,
		6976
	],
	"./pt_BR.json": [
		49728,
		9728
	],
	"./ro.json": [
		55684,
		5684
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70376;
module.exports = webpackAsyncContext;